<template>
  <div class="page-sidebar">
    <!-- Header Slot -->
    <div v-if="$slots.header" class="sidebar-header">
      <slot name="header">
        <h2 class="sidebar-title">{{ title }}</h2>
      </slot>
    </div>

    <!-- Divider (optional) -->
    <div v-if="showDivider" class="sidebar-divider"></div>

    <!-- Body Slot -->
    <div class="sidebar-body">
      <slot name="body">
        <!-- Default Content -->
      </slot>
    </div>

    <!-- Footer Slot (optional) -->
    <div v-if="$slots.footer" class="sidebar-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageSidebar',

  props: {
    title: {
      type: String,
      default: 'Overview'
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: 'auto',
      validator: (value) => ['auto', 'narrow', 'wide'].includes(value)
    }
  },

  computed: {
    sidebarWidthClass() {
      return `sidebar-width-${this.width}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.page-sidebar {
  width: 100%;
  padding: 48px 32px;
  // background-color: #fafafa;
  display: flex;
  flex-basis: 30%;
  flex-direction: column;

  @media (min-width: 992px) {
    // background-color: white;
  padding: 48px 96px 32px 32px;
  }

  // Width variants
  &.sidebar-width-auto {
    @media (min-width: 992px) {
      width: 384px;
    }

    @media (min-width: 1280px) {
      width: 420px;
    }
  }

  &.sidebar-width-narrow {
    @media (min-width: 992px) {
      width: 320px;
    }
  }

  &.sidebar-width-wide {
    @media (min-width: 992px) {
      width: 480px;
    }

    @media (min-width: 1280px) {
      width: 520px;
    }
  }
}

.sidebar-header {
  margin-bottom: 32px;

  @media (min-width: 992px) {
    margin-bottom: 48px;
  }
}

.sidebar-title {
  font-size: 24px;
  font-weight: 300;
  color: var(--color-foreground);
  margin: 0;

  @media (min-width: 992px) {
    font-size: 32px;
  }

  @media (min-width: 1280px) {
    font-size: 36px;
  }
}

.sidebar-divider {
  height: 2px;
  background-color: var(--bs-border-color);
  width: 100%;
  margin-bottom: 24px;
}

.sidebar-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 24px;
  border-top: 1px solid var(--bs-border-color);
}
</style>
